const showPdpModal = (showModal:any, modalID:string) => {
  window.scrollTo(0, 0);
  showModal(modalID);
  document.body.classList.add('overflow-off');
};

export default showPdpModal;
